// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'User settings'"></sub-header>
<div class="info">
  <div class="info__column">
    <div class="info__field">
        <span class="info__field-label">Branch name:</span>
      <span class="info__field-value">{{\$ctrl.branch.name}}</span>
    </div>
    <div class="info__field">
        <span class="info__field-label">Branch code:</span>
      <span class="info__field-value">{{\$ctrl.branch.code}}</span>
    </div>
  </div>

  <div class="info__column">
    <button class="btn btn-success" type="button" ng-if="\$ctrl.userId" ng-click="\$ctrl.changeBranch()"
            command-access="MoveUserBetweenBranches">
      Move to another branch
    </button>
    <button class="btn btn-warning" type="button" ng-click="\$ctrl.configureMfa()"
            ng-if="\$ctrl.canSeeMfa && !\$ctrl.forcedCredentialsUpdateOnly">
       MFA configuration
    </button>
  </div>
</div>
<div class="tab-menu">
  <ul class="nav-tabs">
    <li class="active" ng-if="!\$ctrl.forcedCredentialsUpdateOnly">
      <a data-target="#tab-personal-data" data-toggle="tab" ng-click="\$ctrl.showSaveAndCancelButtons()">
      <span><i ng-show="\$ctrl.userForm.\$invalid" class="icon icon-warning-sign"></i>Personal data</span>
    </a></li>
    <li><a data-target="#tab-password" data-toggle="tab" ng-click="\$ctrl.showSaveAndCancelButtons()">
      <span><i ng-show="\$ctrl.passwordForm.\$invalid" class="icon icon-warning-sign"></i>Credentials</span>
    </a></li>
    <li><a data-target="#tab-audit" data-toggle="tab" ng-click="\$ctrl.hideSaveAndCancelButtons()"
           ng-show="\$ctrl.isExistingUser">
      </i>Audit Trail</span>
    </a></li>
  </ul>
</div>
<div class="tab-content user-details">

  <div class="tab-pane active" id="tab-personal-data">
    <form name="\$ctrl.userForm">
      <div class="form-column">
        <form-section form-title="'Personal data'">
          <form-section-field field-title="'First name'">
            <input
              type="text"
              ng-model="\$ctrl.user.firstName"
              ng-disabled="!\$ctrl.canUpdateUsers || \$ctrl.editingOwnData"
              required
              maxlength="32"/>
          </form-section-field>
          <form-section-field field-title="'Middle name'">
            <input
              type="text"
              ng-model="\$ctrl.user.middleName"
              ng-disabled="!\$ctrl.canUpdateUsers || \$ctrl.editingOwnData"
              maxlength="32"/>
          </form-section-field>
          <form-section-field field-title="'Last name'">
            <input
              type="text"
              ng-model="\$ctrl.user.lastName"
              ng-disabled="!\$ctrl.canUpdateUsers || \$ctrl.editingOwnData"
              required
              maxlength="32"/>
          </form-section-field>
          <form-section-field field-title="'Work position'">
            <input
              type="text"
              ng-model="\$ctrl.user.position"
              ng-disabled="!\$ctrl.canUpdateUsers || \$ctrl.editingOwnData"
              maxlength="64"/>
          </form-section-field>
          <form-section-field field-title="'Employee ID'">
            <input
              type="text"
              ng-model="\$ctrl.user.employeeId"
              ng-disabled="!\$ctrl.canUpdateUsers || \$ctrl.editingOwnData"
              maxlength="32"/>
          </form-section-field>
        </form-section>
        <form-section form-title="'Contact data'">
          <form-section-field field-title="'E-mail address'">
            <input
              type="email"
              ng-model="\$ctrl.user.email"
              ng-disabled="\$ctrl.editingOwnData && !\$ctrl.canUpdateOwnData || !\$ctrl.editingOwnData && !\$ctrl.canUpdateUsers"
              maxlength="64"/>
          </form-section-field>
          <form-section-field field-title="'Mobile no'">
            <telephone ng-model="\$ctrl.user.workPhone"
                       ng-disabled="\$ctrl.editingOwnData && !\$ctrl.canUpdateOwnData || !\$ctrl.editingOwnData && !\$ctrl.canUpdateUsers"></telephone>
          </form-section-field>
        </form-section>
      </div>
      <div class="form-column">
        <form-section form-title="'Access management'">
          <form-section-field field-title="'Username'">
            <input
              type="text"
              maxlength="32"
              ng-model="\$ctrl.user.username"
              ng-disabled="\$ctrl.user.id"
              required/>
          </form-section-field>
          <form-section-field field-title="'Status'">
            <select
              ng-model="\$ctrl.user.enabled"
              ng-disabled="!\$ctrl.canUpdateUsers || !\$ctrl.canChangeStatus || \$ctrl.editingOwnData"
              ng-options="o.value as o.label for o in [{ label: 'Blocked', value: false }, { label: 'Active', value: true }]"
              ng-change="\$ctrl.onStatusChange()"
              ng-required="true">
            </select>
          </form-section-field>
          <form-section-field field-title="'Block category'" ng-if="\$ctrl.user.enabled === false">
            <select
              ng-model="\$ctrl.user.blockCategory"
              ng-disabled="!\$ctrl.canUpdateUsers || !\$ctrl.canChangeStatus || \$ctrl.editingOwnData"
              ng-options="category as category for category in \$ctrl.blockCategoryOptions"
              ng-required="\$ctrl.user.enabled === false">
            </select>
          </form-section-field>
          <form-section-field field-title="'Self-activation'">
            <select
              ng-disabled="!\$ctrl.canUpdateUsers || \$ctrl.editingOwnData"
              ng-model="\$ctrl.user.selfActivationAllowed"
              boolean-options
              required>
            </select>
          </form-section-field>
          <form-section-field field-title="'Account valid since'">
            <date
                  ng-disabled="!\$ctrl.canUpdateUsers || \$ctrl.editingOwnData"
                  output-format="date"
                  ng-model="\$ctrl.user.activationDate"
                  ng-change="\$ctrl.changeActivationDate(\$ctrl.user.activationDate)"
                  ng-required="true"></date>
          </form-section-field>
          <form-section-field field-title="'Account valid until'">
            <date
              ng-disabled="!\$ctrl.canUpdateUsers || \$ctrl.editingOwnData"
              output-format="date"
              min="\$ctrl.minExpirationDate | nxDate"
              ng-model="\$ctrl.user.expirationDate"
              ng-change="\$ctrl.changeExpirationDate(\$ctrl.user.expirationDate)"
              init-with-null="true"></date>
            <span id="expired-err" ng-if="\$ctrl.showExpirationDateError">Expired!</span>
          </form-section-field>
          <form-section-field field-title="'Role'">
            <select
              ng-model="\$ctrl.user.roleId"
              ng-disabled="!\$ctrl.canUpdateUsers || \$ctrl.editingOwnData"
              ng-options="role.id as role.name | prettyEnum for role in \$ctrl.roles"
              ng-required="true"
              ng-change="\$ctrl.onRoleUpdate()">
            </select>
          </form-section-field>
          <form-section-field field-title="'Withdrawals limit'" ng-if="\$ctrl.transactionLimitRequired">
            <cash
              ng-disabled="!\$ctrl.canUpdateUsers || \$ctrl.editingOwnData"
              ng-required="true"
              ng-model="\$ctrl.user.transactionLimit"></cash>
          </form-section-field>
          <form-section-field field-title="'Allow login after working hours'">
            <select
              ng-disabled="!\$ctrl.canUpdateUsers || \$ctrl.editingOwnData"
              ng-model="\$ctrl.user.loginAfterHoursAllowed"
              boolean-options
              required>
            </select>
          </form-section-field>
          <form-section-field field-title="'Force logout after working hours'"
                              ng-if="\$ctrl.user.loginAfterHoursAllowed === false">
            <select
              ng-disabled="!\$ctrl.canUpdateUsers || \$ctrl.editingOwnData"
              ng-model="\$ctrl.user.autoLogout"
              boolean-options
              ng-required="true">
            </select>
          </form-section-field>
          <form-section-field field-title="'Available branches'">
            <multiselect
              ng-disabled="!\$ctrl.canUpdateUsers || \$ctrl.editingOwnData"
              ng-required="true"
              items="\$ctrl.branches"
              ng-model="\$ctrl.user.branchIds"
              label-property="'name'"
              value-property="'id'"
              select-all-option="true"
            >
            </multiselect>
          </form-section-field>
          <form-section-field field-title="'Technical user'">
            <select required
                    ng-disabled="!\$ctrl.canUpdateUsers || \$ctrl.editingOwnData"
                    boolean-options
                    ng-model="\$ctrl.user.technical">
            </select>
          </form-section-field>
        </form-section>
      </div>
    </form>
  </div>
  <div class="tab-pane" id="tab-password">
    <form name="\$ctrl.passwordForm">
      <div class="form-column" ng-hide="\$ctrl.hideCredentialsForm('PASSWORD')">
        <form-section form-title="'Password'">
          <form-section-field field-title="'Old password'" ng-if="\$ctrl.userId">
            <input
              type="password"
              ng-model="\$ctrl.oldPassword"
              ng-disabled="!\$ctrl.editingOwnData || !\$ctrl.userId"
              ng-required="(\$ctrl.userId && \$ctrl.retypedPassword && \$ctrl.editingOwnData) || \$ctrl.isCredentialsRequired('PASSWORD')"/>
          </form-section-field>
          <form-section-field field-title="'New password'">
            <password
              ng-disabled="!\$ctrl.canUpdateUsersCredentials && !\$ctrl.editingOwnData"
              model="\$ctrl.user.password"
              complexity-rules="\$ctrl.complexityRules"
              ng-required="!\$ctrl.userId || \$ctrl.isCredentialsRequired('PASSWORD')">
            </password>
          </form-section-field>
          <form-section-field field-title="'Retype new password'">
            <input
              name="passwordretype"
              type="password"
              ng-model="\$ctrl.retypedPassword"
              ng-disabled="!\$ctrl.canUpdateUsersCredentials && !\$ctrl.editingOwnData"
              ng-required="\$ctrl.user.password"
              validate-password="{{\$ctrl.user.password}}"/>
          </form-section-field>
          <form-section-field field-title="" ng-if="\$ctrl.passwordForm.passwordretype.\$invalid">
            <p ng-if="\$ctrl.passwordForm.passwordretype.\$error.validatePassword">Passwords don't match</p>
          </form-section-field>
          <form-section-field field-title="'Force password update on first login'" ng-if="\$ctrl.retypedPassword && !\$ctrl.editingOwnData">
            <input type="checkbox"
                   ng-model="\$ctrl.user.forcePasswordUpdate"
                   ng-disabled="!\$ctrl.canUpdateUsersCredentials && \$ctrl.editingOwnData"/>
          </form-section-field>
        </form-section>
      </div>

      <div class="form-column" ng-hide="\$ctrl.hideCredentialsForm('PIN')">
        <form-section form-title="'PIN'">
          <form-section-field field-title="'Change PIN'">
            <input
              type="password"
              name="pin"
              ng-model="\$ctrl.user.pin"
              maxlength="4"
              validate-pin
              ng-disabled="!\$ctrl.canUpdateUsersCredentials && !\$ctrl.editingOwnData"
              ng-required="!\$ctrl.userId || \$ctrl.isCredentialsRequired('PIN')"/>
          </form-section-field>
          <form-section-field field-title="" ng-if="\$ctrl.passwordForm.pin.\$invalid">
            <p ng-if="\$ctrl.passwordForm.pin.\$error.validatePin">Pin should be 4 digits</p>
          </form-section-field>
          <form-section-field field-title="'Force PIN update on first login'" ng-if="\$ctrl.user.pin && !\$ctrl.editingOwnData">
            <input type="checkbox"
                   ng-model="\$ctrl.user.forcePinUpdate"
                   ng-disabled="!\$ctrl.canUpdateUsersCredentials && \$ctrl.editingOwnData"/>
          </form-section-field>
        </form-section>
      </div>
    </form>
  </div>
  <div class="tab-pane" id="tab-audit">
          <table class="table ">
            <tbody>
            <tr>
              <td><span class="label">Created by:</span></td>
              <td><span>{{\$ctrl.createdByUserName}}</span></td>
            </tr>
            <tr>
              <td><span class="label">Created at:</span></td>
              <td><span>{{\$ctrl.user.createdAt}}</span></td>
            </tr>
            <tr>
              <td><span class="label">Last update by:</span></td>
              <td><span>{{\$ctrl.updatedByUserName}}</span></td>
            </tr>
            <tr>
              <td><span class="label">Last update at:</span></td>
              <td><span>{{\$ctrl.user.updatedAt}}</span></td>
            </tr>
            </tbody>
          </table>

  </div>

  <div class="clearfix"></div>

  <div class="buttons">
    <button class="btn btn-warning"
            ng-disabled="\$ctrl.userForm.\$pristine && \$ctrl.passwordForm.\$pristine"
            ng-show="(!\$ctrl.saveAndCancelButtonAreHidden)"
            ng-click="\$ctrl.cancelChanges()">Cancel
    </button>
    <button class="btn btn-primary"
            ng-disabled="(\$ctrl.userForm.\$pristine && \$ctrl.passwordForm.\$pristine) ||
                          \$ctrl.userForm.\$invalid || \$ctrl.passwordForm.\$invalid"
            ng-show="(!\$ctrl.saveAndCancelButtonAreHidden)"
            ng-click="\$ctrl.save()">Save
    </button>
  </div>

  <div class="clearfix"></div>
</div>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/users/details/users-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;